





















































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  UserWalletDetailed,
  UserGoldDetailed,
  screenFactor,
  pcScreenFactor,
} from "@/req/pay";
import { operation } from "./index.js";
@Component
export default class Home extends Vue {
  public modal = false;
  public activeTabs = 0; // 初始默认
  public gainSum = "";
  public costSum = "";
  public page = 1;
  public pageSize = 20;
  public dataCount = 0;
  public loading = false;
  public dateTime = "";
  public tabs = [
    {
      name: "盒币",
    },
    {
      name: "金币",
    },
  ];
  public futureTime = {
    disabledDate(date) {
      return date && date.valueOf() > Date.now();
    },
  };
  public versionList = {};
  public data = [];
  public tableData: any = [];
  public column = operation.columnsBalance;
  public sStime = "";
  public eEtime = "";
  public versionid = "";
  @Watch("modal")
  public isChange(val) {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }
  public show() {
    this.dateTime = this.sStime = this.eEtime = this.versionid = "";
    this.activeTabs = 0;
    this.getList();
    // this.factor();
    this.pcFactor();
    this.modal = true;
    this.$nextTick(() => {
      document
        .getElementsByClassName("ivu-table-body")[0]
        .addEventListener("scroll", (event) => {
          const obj: any = event.target;
          if (
            obj.scrollTop + obj.clientHeight > obj.scrollHeight - 30 &&
            this.tableData.length % this.pageSize == 0
          ) {
            this.page++;
            const start = (this.page - 1) * this.pageSize;
            const end = this.page * this.pageSize;
            this.tableData = this.tableData.concat(this.data.slice(start, end));
          }
        });
    });
  }
  public tabsSkip(index) {
    this.activeTabs = index;
    this.dateTime = this.sStime = this.eEtime = this.versionid = "";
    if (index == 0) {
      this.column = operation.columnsBalance;
    } else if (index == 1) {
      this.column = operation.columnsGold;
    }
    this.getList();
  }
  public async getList() {
    this.loading = true;
    this.page = 1;
    this.tableData = this.data = [];
    const obj = {
      token: this.$fn.cookies.getToken(),
      stime: this.sStime,
      etime: this.eEtime,
      type: this.versionid == undefined ? "" : this.versionid,
    };
    let res;
    if (this.activeTabs == 0) {
      res = await UserWalletDetailed(obj);
      if (res.code == 200) {
        this.data = res.data.balanceDetail;
        this.dataCount = res.data.balanceDetail.length;
        this.gainSum = res.data.income;
        this.costSum = res.data.expend;
        if (res.data.balanceDetail.length < this.pageSize) {
          this.tableData = this.data;
        } else {
          this.tableData = this.data.slice(0, this.pageSize);
        }
      }
    } else if (this.activeTabs == 1) {
      res = await UserGoldDetailed(obj);
      if (res.code == 200) {
        this.data = res.data.goldDetail;
        this.dataCount = res.data.goldDetail.length;
        this.gainSum = res.data.income;
        this.costSum = res.data.expend;
        if (res.data.goldDetail.length < this.pageSize) {
          this.tableData = this.data;
        } else {
          this.tableData = this.data.slice(0, this.pageSize);
        }
      }
    }
    this.loading = false;
  }
  public changeDate(date) {
    this.sStime = date[0];
    this.eEtime = date[1];
    this.getList();
  }
  public changeType() {
    this.getList();
  }
  public async factor() {
    const res = await screenFactor({
      token: this.$fn.cookies.getToken(),
    });
    if (res.code === 200) {
      this.versionList = res.data;
    }
  }
  public async pcFactor() {
    const res = await pcScreenFactor({
      token: this.$fn.cookies.getToken(),
    });
    if (res.code === 200) {
      this.versionList = res.data;
    }
  }
}
